import { Plugins } from '@leverege/plugin';
import Attributes from "../Attributes.js";
function processor(normalizers) {
  const named = new Map(); // attrName -> Normalizer lookup
  const types = new Map(); // valueType -> Normalizer lookup

  for (let i = 0; i < normalizers.length; i++) {
    const normalizer = normalizers[i];
    const nNormalizer = named.get(normalizer.attrName);
    if (nNormalizer == null && normalizer.attrName != null) {
      named.set(normalizer.attrName, normalizer);
    }
    const tNormalizer = types.get(normalizer.valueType);
    if (tNormalizer == null && normalizer.valueType) {
      types.set(normalizer.valueType, normalizer);
    } else if (normalizer.valueType) {
      console.warn(`Normalizer for value type ${normalizer.valueType} already set, ignoring`, normalizer);
    }
  }
  return {
    named,
    types
  };
}
const view = Plugins.createView('Normalizer', {
  processor
});
const resolveAction = (attrName, val, opts, action) => {
  const {
    named,
    types
  } = view.get();
  const nObj = named.get(attrName);
  if (nObj) {
    return nObj.normalizer[action](val, opts);
  }
  const valueType = Attributes.getValueType(attrName);
  const tObj = types.get(valueType);
  if (tObj) {
    return tObj.normalizer[action](val, opts);
  }
  return val;
};
export default {
  normalize: (attrName, obj, opts) => {
    return resolveAction(attrName, obj, opts, 'normalize');
  },
  denormalize: (attrName, val, opts) => {
    return resolveAction(attrName, val, opts, 'denormalize');
  }
};